export const ShippingMethodsModelModule = angular
    .module('app.services.model.models.shippingMethodsModel', [])
    .value('shippingMethodsModel', {
        id: 'String',
        createdOn: ['String', undefined],
        updatedOn: ['String', undefined],
        name: 'String',
        shippingBand: {
            totalThreshold: 'Number',
            shippingPrice: 'Number'
        },
        shippingBands: {
            byPrice: {
                enabled: 'Boolean',
                bands: 'Array'
            },
            byWeight: {
                enabled: 'Boolean',
                bands: 'Array'
            },
            free: {
                enabled: 'Boolean',
                deliveryEstimate: 'String',
                priceThreshold: 'any',
                shippingZones: {
                    exclude: 'Array'
                }
            },
            curbside: {
                enabled: 'Boolean',
                pickupAddress: {
                    address1: ['String', undefined],
                    address2: ['String', undefined],
                    city: ['String', undefined],
                    state: ['String', undefined],
                    postalCode: ['String', undefined],
                    phoneNumber: ['String', undefined]
                }
            }
        },
        revision: 'Number'
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/model/models/shippingMethods.model.js